
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import T6 from '../../components/ExcerciseTypes/TypeIn/T6';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';


const json = {
  1: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P37-E1',
    audio: 'img/FriendsPlus/Page36/Audio/audio-e2-p36.mp3',
    video: 'Videos/e2.p36.mp4',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E1/1.jpg' },

      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page36/E2/4.jpg', audioUrl: 'img/FriendsPlus/Page36/Audio/hinh1-e2-p36.mp3' },
        { url: 'img/FriendsPlus/Page36/E2/5.jpg', audioUrl: 'img/FriendsPlus/Page36/Audio/hinh2-e2-p36.mp3' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page36/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page36/Audio/hinh3-e2-p36.mp3' },
        { url: 'img/FriendsPlus/Page36/E2/7.jpg', audioUrl: 'img/FriendsPlus/Page36/Audio/hinh4-e2-p36.mp3' },
      ],

    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P37-E2',
    audio: 'img/FriendsPlus/Page37/Audio/audio-e2-p37.mp3',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page37/Audio/tieude-e2-p37.mp3' },
        { url: 'img/FriendsPlus/Page37/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page37/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page37/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/6.jpg', audioUrl: 'img/FriendsPlus/Page37/Audio/doan1.mp3' },
        { url: 'img/FriendsPlus/Page37/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page37/E2/8.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/9.jpg', audioUrl: 'img/FriendsPlus/Page37/Audio/doan2.mp3' },
        { url: 'img/FriendsPlus/Page37/E2/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page37/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page37/E2/12.jpg', audioUrl: 'img/FriendsPlus/Page37/Audio/doan3.mp3' },
        { url: 'img/FriendsPlus/Page37/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page37/E2/14.jpg' },
      ],

    ],
  },
  3: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P37-E3',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page37/E3/Key/answerKey.png',
    component: DesignUnderLine,
    totalInput: 3,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page37/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/3.jpg', input: 1, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E3/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page37/E3/5.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/6.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page37/E3/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page37/E3/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page37/E3/9.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/10.jpg', input: 2, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/12.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page37/E3/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page37/E3/14.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/15.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page37/E3/16.jpg' },
        { url: 'img/FriendsPlus/Page37/E3/17.jpg', input: 3, isCorrect: true },
        { url: 'img/FriendsPlus/Page37/E3/18.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page37/E3/19.jpg' },
      ],

    ],
  },
  4: { // Exercise num
    unit: 'Unit 5 ',
    id: 'SB4-U5-P37-E4',
    audio: '',
    video: '',
    component: T6,
    checkUppercase: true,
    exerciseKey: 'img/FriendsPlus/Page37/E4/Key/answerKey.png',
    titleImage: "img/FriendsPlus/Page37/E4/1.jpg",
    inputSize: 200,
    // titleQuestion: [{ num: '2', title: 'Write about A or B.' }],
    questionImage: [],
    questions: [
      {
        title:
          `
      <div><b> 1 </b>  Are the kangaroos jumping? <u style='color:rgb(82,197,235)'>No, they aren't</u>.</div>
      <div><b> 2 </b> Is the Lizard sleeping? #</div>
      <div><b> 3 </b> Is the woman painting? #</div>
      <div><b> 4 </b> Are the monkey eating? #</div>
      
      `,
        answer: [
          "Yes, it is.",
          "No, she isn't.",
          "Yes, they are.",
        ],
        // type: 'longAnwser'
      },
    ]
  },
  5: { // Exercise num
    unit: 'Unit 5',
    id: 'SB4-U5-P37-E5',
    audio: '',
    video: '',
    recorder: true,
    component: UI,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page37/E5/1.jpg' },
      ]
    ],
  },

}

export default json;
